export default __webpack_public_path__ + "static/media/New-HGN-Icon-11kb-200x160px.33e45315.png";